import { SB } from '@play-co/replicant';
import {
  createFlexContainer,
  createFlexMessageTemplate,
  createOpenGameAction,
} from './utils';
import { CRATE_WAITING_CREATIVE_IDS } from '../../crateWaiting/crateWaiting.ruleset';

// Asset keys live in the ruleset (decoupled from this flex module); re-export
// for the asset registry in ./index.
export { crateWaitingAssets } from '../../crateWaiting/crateWaiting.ruleset';

const altTextByLocale: Record<'en' | 'ja', string> = {
  en: 'Your pet is waiting in the crate to meet you!',
  ja: 'ペットがクレートの中であなたを待っています！',
};

/**
 * Crate-waiting flex message. Mirrors `spawnPetMessage` — a single full-bleed
 * creative image that opens the game on tap, with `creativeAssetID` carried in
 * the payload for attribution on `ChatbotMessageSuccess`.
 */
export const crateWaitingMessage = createFlexMessageTemplate(
  SB.object({
    creativeAssetID: SB.tuple(CRATE_WAITING_CREATIVE_IDS),
    locale: SB.tuple(['en', 'ja']),
  }),
  (data, payload, api) => {
    const altText = altTextByLocale[data.locale];
    // Each creative ships an `_en` and `_ja` asset; resolve the recipient's
    // locale (mirrors `reengagementMessage`). `ja` is the default (see getLocale).
    const background = api.getAssetPath(
      `${data.creativeAssetID}/${data.locale}`,
    );

    return createFlexContainer(altText, {
      type: 'bubble',
      size: 'giga',
      action: createOpenGameAction(altText, payload),
      body: {
        type: 'box',
        layout: 'horizontal',
        contents: [
          {
            type: 'image',
            url: background,
            size: 'full',
            aspectMode: 'cover',
            aspectRatio: '1:1',
            gravity: 'center',
          },
        ],
        paddingAll: '0px',
        justifyContent: 'center',
      },
    });
  },
);
